import React from 'react'

export default function PencilIcon({className}:any) {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M2.91243 14.8243L0.656576 15.6934C0.539388 15.739 0.431966 15.7097 0.33431 15.6055C0.243164 15.5079 0.220378 15.4004 0.265951 15.2833L1.19368 13.1055L11.8577 2.46099L13.5667 4.17974L2.91243 14.8243ZM14.4261 3.3399L12.6976 1.62115L13.6839 0.644587C13.9313 0.403702 14.182 0.273494 14.4359 0.253962C14.6963 0.234431 14.9372 0.335343 15.1585 0.556697L15.4906 0.888728C15.7184 1.11659 15.8258 1.35748 15.8128 1.61138C15.7998 1.86529 15.6663 2.1192 15.4124 2.3731L14.4261 3.3399Z" className={className || "white"}/>
		</svg>
	)
}
